import React from 'react'
import ReactDOM from 'react-dom'
import TagBox from './TagBox'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import '../css/searchbox.css'

export default class SearchBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      categoryChoice: '0',
      publicChoice: '0',
      tagsFromTagBox: [],
      favoriteNotif: [],
    }
  }

  handleChange(event) {
    this.setState({categoryChoice: event.target.value})
  }

  handleTrackerChange(event) {
    this.setState({trackerChoice: event.target.value})
  }

  launchSearch() {
    const initialQuery = ReactDOM.findDOMNode(this.refs.query).value
    const category = ReactDOM.findDOMNode(this.refs.category).value
    const tracker = ReactDOM.findDOMNode(this.refs.tracker).value
    let query = initialQuery
    if (this.state.tagsFromTagBox.length) {
      query = initialQuery + ' ' + this.state.tagsFromTagBox.join(' ')
    }
    // empty query will trigger a wide search
    if (initialQuery === '') {
      this.props.search('', category, tracker)
    } else {
      this.props.search(query, category, tracker)
    }
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.launchSearch()
    }
  }

  addFavorite() {
    let query = ReactDOM.findDOMNode(this.refs.query).value
    let cid = ReactDOM.findDOMNode(this.refs.category).value
    this.props.addFavorite(query, cid, this.state.tagsFromTagBox, (result) => {
      if (result) {
        this.setState({favoriteNotif: ['OK!']})
      } else {
        this.setState({favoriteNotif: ['FAILED :-(']})
      }
      setTimeout(() => {
        this.setState({favoriteNotif: []})
      }, 2000)
    })
  }

  tagsChange(notifiedTags) {
    let updatedTags = []
    notifiedTags.forEach(function (tagData) {
      if (updatedTags.indexOf(tagData.text) === -1) {
        updatedTags.push(tagData.text)
      }
    })
    this.setState({tagsFromTagBox: updatedTags})
  }

  render() {
    const notif = this.state.favoriteNotif.map((item, i) => (
      <div key={item} className="form-group">{item}</div>
    ))
    return (
      <div>
        <div className="from-group form-inline">
          <input type="text" ref="query" className="form-control" onKeyDown={this.handleKeyDown.bind(this)} />
          <select ref="category" className="form-control" value={this.state.categoryChoice} onChange={this.handleChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}>
            <option value="All">Toutes catégories</option>
            <option value="Audio">Audio</option>
            <option value="eBook">eBook</option>
            <option value="Emulation">Emulation</option>
            <option value="Jeu vidéo">Jeu vidéo</option>
            <option value="GPS">GPS</option>
            <option value="Application">Application</option>
            <option value="Film/Vidéo">Film/Vidéo</option>
            <option value="Série">Série</option>
            <option value="xXx">xXx</option>
          </select>
          <select ref="tracker" className="form-control" value={this.state.trackerChoice} onChange={this.handleTrackerChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}>
            <option value="yggtorrent">YggTorrent</option>
            <option value="public">Trackers publiques</option>
          </select>
          <input type="submit" className="btn btn-primary" onClick={this.launchSearch.bind(this)} value="Rechercher" />
          <input type="submit" ref="favorite" className="btn btn-danger" onClick={this.addFavorite.bind(this)} value="Ajouter aux favoris" />
          <ReactCSSTransitionGroup
            transitionName="favorite-notif"
            transitionEnterTimeout={300}
            transitionLeaveTimeout={500}>
            {notif}
          </ReactCSSTransitionGroup>
        </div>
        <TagBox notifyParent={this.tagsChange.bind(this)} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/search/SearchBox.js